// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useMemo, useEffect } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import {
  Activity,
  ActivitySource,
  ActivitySourceValue,
  BookingOption,
} from '../../../../types/Activity';
import { StripeAccount } from '../../../../types/Stripe';
import {
  getIsNotIntegrationEnabled,
  hasNoBookingPlatformIntegration,
  isFareharborSource as getIsFareharborSource,
} from '../../../forms/EditPeekAndRedeamOrderForm/helpers';
import { PartyType } from '../../../../types/Party';
import { ActivityContext } from '../../../../contexts/Activity';

import ActivityCreateModalContent from './ActivityCreateModalContent';
import BookingOptionsCreateData from './BookingOptionsCreateData';

const StyledTabs = styled.ul`
  display: flex;
  margin: 0;
  li {
    list-style-type: none;
    margin-right: 10px;
    color: #43a5c6;
    cursor: pointer;
  }

  button {
    background: inherit;
    outline: none;
    border: none;
    padding: 6px 30px 5px 30px;
    margin: 0;
  }

  .active {
    background: #ffffff;
    color: #000000;
    border: 1px solid #d9d9d9;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom: 0;
  }

  [disabled] {
    opacity: 0.6;
  }
`;

const DISPLAY_OPTIONS = {
  activities: 'activities',
  bookingOptions: 'bookingOptions',
};

type Props = {
  fieldsValue: Partial<Activity>;
  onChange: (fieldKey: string, value: unknown) => void;
  onFormSubmit: () => void;
  allTags: string[];
  onChangeCategory: (categoryId: string, subCategoryId: string) => void;
  bookingOptionsData: {
    label: string;
    title: string;
  }[];
  onAddBookingOption: (bookingOption: Partial<BookingOption>) => void;
  showActivitySelector?: boolean;
  onActivitySelect: (activity: Activity | undefined) => void;
  onDeleteBookingOption: (id: string) => void;
  isNotIntegrationEnabled: boolean;
  isBookingPlatformIntegrationAbsent: boolean;
  stripeAccounts: StripeAccount[];
  existingSource?: ActivitySourceValue;
  isFareharborSource?: boolean;
  partyTypes: PartyType[];
};

const ActivityCreateModalWrapper = ({
  fieldsValue,
  onChange,
  onFormSubmit,
  allTags,
  bookingOptionsData,
  onAddBookingOption,
  showActivitySelector,
  onActivitySelect,
  onChangeCategory,
  onDeleteBookingOption,
  isNotIntegrationEnabled,
  stripeAccounts,
  existingSource,
  partyTypes,
  isBookingPlatformIntegrationAbsent,
  isFareharborSource,
}: Props) => {
  const [displayedTab, setDisplayedTab] = useState(DISPLAY_OPTIONS.activities);
  const [selectedBookingOption, setSelectedBookingOption] = useState(-1);
  const [bookingOptionCreateDataKey, setBookingOptionCreateDataKey] = useState(
    0
  ); // for deep editor purposes

  const [selectedActivity, setSelectedActivity] = useState<
    Activity | undefined
  >();
  const [_notIntegrationEnabled, setNotIntegrationEnabled] = useState<
    boolean | undefined
  >(isNotIntegrationEnabled);

  let _isFareharborSource = isFareharborSource;

  if (existingSource) {
    _isFareharborSource = getIsFareharborSource(
      existingSource as ActivitySource
    );
  } else if (!!selectedActivity && selectedActivity.source) {
    _isFareharborSource = getIsFareharborSource(selectedActivity.source);
  }

  const [
    _isBookingPlatformIntegrationAbsent,
    setIsBookingPlatformIntegrationAbsent,
  ] = useState<boolean>(isBookingPlatformIntegrationAbsent);

  const isBookingOptionsTabAvailable = useMemo(
    () => fieldsValue?.tags?.includes('bookable'),
    [fieldsValue?.tags]
  );

  useEffect(() => {
    setBookingOptionCreateDataKey(bookingOptionCreateDataKey + 1);
  }, [JSON.stringify(selectedBookingOption)]);

  useEffect(() => {
    setNotIntegrationEnabled(
      getIsNotIntegrationEnabled(selectedActivity?.source) ||
        isNotIntegrationEnabled
    );
  }, [isNotIntegrationEnabled, selectedActivity?.source]);

  useEffect(() => {
    setIsBookingPlatformIntegrationAbsent(() => {
      if (typeof selectedActivity?.source !== 'undefined') {
        return hasNoBookingPlatformIntegration(selectedActivity?.source);
      }
      return isBookingPlatformIntegrationAbsent;
    });
  }, [isBookingPlatformIntegrationAbsent, selectedActivity?.source]);

  const onActivitySelected = (activity: Activity | undefined) => {
    setSelectedActivity(activity);
    onActivitySelect(activity);
  };

  return (
    <ActivityContext.Provider value={{ source: selectedActivity?.source }}>
      <StyledTabs>
        <li>
          <button
            type='button'
            onClick={() => setDisplayedTab(DISPLAY_OPTIONS.activities)}
            className={`${
              displayedTab === DISPLAY_OPTIONS.activities ? 'active' : ''
            }`}
          >
            Experiences
          </button>
        </li>
        <li>
          <button
            type='button'
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            onClick={() => setDisplayedTab(DISPLAY_OPTIONS.variants)}
            disabled={!isBookingOptionsTabAvailable}
            className={`${
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              displayedTab === DISPLAY_OPTIONS.variants ? 'active' : ''
            }`}
          >
            BookingOptions
          </button>
        </li>
      </StyledTabs>
      {displayedTab === DISPLAY_OPTIONS.activities ? (
        <ActivityCreateModalContent
          onChangeCategory={onChangeCategory}
          fieldsValue={fieldsValue}
          onChange={onChange}
          onFormSubmit={onFormSubmit}
          isNotIntegrationEnabled={_notIntegrationEnabled}
          isBookingPlatformIntegrationAbsent={
            _isBookingPlatformIntegrationAbsent
          }
          allTags={allTags}
          bookingOptionsData={bookingOptionsData}
          existingSource={existingSource}
          stripeAccounts={stripeAccounts}
          showActivitySelector={showActivitySelector}
          onActivitySelect={onActivitySelected}
          partyTypes={partyTypes}
        />
      ) : (
        <BookingOptionsCreateData
          isNotIntegrationEnabled={_notIntegrationEnabled}
          key={bookingOptionCreateDataKey}
          isFareharborSource={_isFareharborSource}
          addedBookingOptions={bookingOptionsData}
          onAddBookingOption={onAddBookingOption}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          selectedBookingOption={selectedBookingOption}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          setSelectedBookingOption={setSelectedBookingOption}
          onDeleteBookingOption={onDeleteBookingOption}
        />
      )}
    </ActivityContext.Provider>
  );
};

// eslint-disable-next-line import/no-unused-modules
export default ActivityCreateModalWrapper;
